import React from 'react';
import { FAQ_TYPES } from 'pages/ApplicationUI/constant';
import FAQList from '../FAQList';

const IndianFAQ = () => {
  return (
    <div>
      <FAQList countryType={FAQ_TYPES.INDIAN_FAQ} />
    </div>
  );
};

export default IndianFAQ;
